import { useCourseRevisionState } from './store.js';
import { getChaptersInCourse } from './util.get-chapters-in-course.js';

function useCanDisableChapterInRevision(courseDescriptor, ignoredChapterDescriptors) {
  const ignoredChapterDescriptorsArray = !ignoredChapterDescriptors ? [] : Array.isArray(ignoredChapterDescriptors) ? ignoredChapterDescriptors : [ignoredChapterDescriptors];
  const chaptersInCourse = getChaptersInCourse(courseDescriptor);
  const canDisableChapterInRevision = useCourseRevisionState(state => chaptersInCourse.filter(chapter => !state.disabledIds[chapter.id]?.disabled && !ignoredChapterDescriptorsArray.some(it => it.id === chapter.id)).length > 0);
  return canDisableChapterInRevision;
}

export { useCanDisableChapterInRevision };
//# sourceMappingURL=hook.can-disable-chapter-in-revision.js.map
